import type { ReactNode } from 'react';
import { usePermissions } from '@/presentation/contexts/permissionsContextCore';

/**
 * Muestra `children` solo si el usuario (o el rol simulado) tiene el permiso.
 * Owner real ve todo; en modo simulación aplica el set del rol.
 */
export function PermissionGate({
  permission,
  children,
  fallback = null,
}: {
  permission: string;
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const { hasPermission } = usePermissions();
  return <>{hasPermission(permission) ? children : fallback}</>;
}
